import { createSlice } from "@reduxjs/toolkit";

import { addGeneralAvailabilityChefAPI } from "../../../../api/chef";
import { sliceHandler } from "../../utils";

const addGeneralAvailabilityChef = createSlice(
    sliceHandler({
        name: 'addGeneralAvailabilityChef',
        action: 'addGeneralAvailabilityChefSlice',
        success: 'addGeneralAvailabilityChefSliceSuccess',
        failure: 'addGeneralAvailabilityChefSliceFailure',
        reset: 'addGeneralAvailabilityChefSliceReset'
    })
);

const addGeneralAvailabilityChefAction: any = addGeneralAvailabilityChef.actions;
const addGeneralAvailabilityChefHandler = (data: any) => async (dispatch: any) => {
    try {
        dispatch(addGeneralAvailabilityChefAction.addGeneralAvailabilityChefSlice());
        const response: any = await addGeneralAvailabilityChefAPI(data);
        dispatch(addGeneralAvailabilityChefAction.addGeneralAvailabilityChefSliceSuccess(response));
    } catch (e: any) {
        dispatch(addGeneralAvailabilityChefAction.addGeneralAvailabilityChefSliceFailure(e?.response?.data));
    }
};

export {
    addGeneralAvailabilityChefAction,
    addGeneralAvailabilityChefHandler,
}

export default addGeneralAvailabilityChef.reducer;